/**
 * External dependencies
 */
import { HeaderIcon } from '~cartzillagb/icons'
import { range, createButtonAttributes } from '~cartzillagb/util'
import {
    disabledBlocks, i18n, srcUrl
} from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'


/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'

import { compose } from '@wordpress/compose'
import {
    RichText,
} from '@wordpress/block-editor'

/**
 * Internal dependencies
 */
import { name } from './index'

/**
 * External dependencies
 */
import classnames from 'classnames'

import PlaceholderImage  from  './img/ph-img.jpg'

const schema_1 = {
    blockId: {
        type: 'string',
        default: '',
    },

    limit: {
        type: 'number',
        default: 1,
    },

    enableButton: {
        type: 'boolean',
        default: true,
    },

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit_1 = applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit_1 + 1 ).map( i => {
    schema_1[ `title${ i }` ] = {
        type: 'string',
    }
    schema_1[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema_1[ `buttontitle${ i }` ] = {
        type: 'string',
    }
    schema_1[ `backgroundImage${ i }` ] = {
        type: 'string',
    }
    schema_1[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema_1[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema_1[ `mediaURL${ i }` ] = {
        type: 'string',
    }
    schema_1[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_1[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_1[ `enablebuttonTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
     schema_1[ `enableButton${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_1[ `titleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_1[ `titleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_1[ `subtitleAnimation${ i }` ] = {
        type: 'string',
        default: 'from-bottom'
    }
    schema_1[ `subtitleDelay${ i }` ] = {
        type: 'string',
        default: 'delay-2'
    }
    schema_1[ `buttontitleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_1[ `buttontitleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_1[ `btnlimit${ i }` ] = {
        type: 'number',
        default: 2,
    }

    const Maxbtnlimit_1 = applyFilters( 'cartzillagb.market-button.btnlimit.edit.inspector.max.btnlimit', 4 )

    { range( 1, Maxbtnlimit_1 + 1 ).map( j => {
        schema_1[ `btnpretitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_1[ `btntitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_1[ `btnbgcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_1[ `btnbgcustomcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_1[ `btnicon${ i }${ j }` ] = {
            type: 'string',
        }
        schema_1[ `btnlink${ i }${ j }` ] = {
            type: 'string',
        }
        return ''
    } ) }

    schema_1[ `btnpretitle${ i }` ] = {
        type: 'string',
    }
    return ""
} ) }

const save_1 = props => {
    const { 
        attributes,
        className,
        
        // Carousel
    } = props 

    const {
        blockId,
        limit,
    } = attributes

    const mainClasses = classnames( [
        'cz-carousel',
        'mb-4',
        'mb-sm-5',
        className,
    ], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

    const content = range( 1, limit + 1 ).map( i => {

        const Title = attributes[ `title${ i }` ]
        const subTitle = attributes[ `subtitle${ i }` ]
        const ButtonTitle = attributes[ `buttontitle${ i }` ]
        const MediaURL = attributes[ `mediaURL${ i }` ]
        const bgColor = attributes[ `bgcolor${ i }` ]
        const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
        const enableTitle = attributes[ `enableTitle${ i }` ]
        const enablesubTitle = attributes[ `enablesubTitle${ i }` ]
        const enablebuttonTitle = attributes[ `enablebuttonTitle${ i }` ]
        const btnlimit = attributes[ `btnlimit${ i }` ]
        const enableButton = attributes[ `enableButton${ i }` ]

        let defaultTitle = ''
        let defaultSubtitle = ''
        let defaultButtonTitle = ''
        let defaultbgColor = ''
        const defaultImg = `${ srcUrl }/${ PlaceholderImage }`

        if ( i % 5 === 1 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 2 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 3 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 4 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 0 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }

        const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

        const titleComp = enableTitle && (
            <RichText.Content
                tagName="h2"
                className={ `h1 text-light` } 
                value={ Title || defaultTitle }
            />
        )

        const subtitleComp = enablesubTitle &&  (
            <RichText.Content
                tagName="p"
                value={ subTitle || defaultSubtitle }
                className={ `text-light pb-4` }
            />
        )

        const buttontitleComp = enablebuttonTitle && (
            <RichText.Content
                tagName="h5"
                className={ `text-light pb-3 text-light` } 
                value={ ButtonTitle || defaultButtonTitle }
            />
        )


        const btncontent = range( 1, ( btnlimit ) + 1 ).map( j => {
            const btnPreTitle = attributes[ `btnpretitle${ i }${ j }` ]
            const btnTitle = attributes[ `btntitle${ i }${ j }` ]
            const btnbgColor = attributes[ `btnbgcolor${ i }${ j }` ]
            const btnbgcustomColor = attributes[ `btnbgcustomcolor${ i }${ j }` ]
            const btnicon = attributes[ `btnicon${ i }${ j }` ]
            const btnlink = attributes[ `btnlink${ i }${ j }` ] !== undefined ? attributes[ `btnlink${ i }${ j }` ]  : '#'

            let defaultbtntitle = ''
            let defaultbtnpretitle = ''
            let defaultbtnIcon = ''

            if ( (j % 4 ) === 1 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "App Store"
                defaultbtnIcon = 'btn-apple'
            }

            if ( (j % 4 ) === 2 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Google Play"
                defaultbtnIcon = 'btn-google'
            }

            if ( (j % 4 ) === 3 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Windows Store"
                defaultbtnIcon = 'btn-windows'
            }

            if ( (j % 4 ) === 0 ) { 
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Amazon.com"
                defaultbtnIcon = 'btn-amazon'
            }

            const btnbgstyle = { backgroundColor: btnbgcustomColor && btnbgcustomColor }

            const btniconClass = classnames( [
                btnicon === 'none' && '',
                btnicon === 'btn-apple' && ' btn-apple',
                btnicon === 'btn-google' && ' btn-google',
                btnicon === 'btn-windows' && ' btn-windows',
                btnicon === 'btn-amazon' && ' btn-amazon'
            ] )

            const btnpretitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-subtitle"
                    value={ btnPreTitle || defaultbtnpretitle }
                />
            )

            const btntitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-title"
                    value={ btnTitle || defaultbtntitle }
                />
            )

            const output = (
                <a className={ `btn-market ${ btniconClass || defaultbtnIcon } mr-2 mb-2 ${ btnbgColor ? btnbgColor : btnbgcustomColor ? '' : '' }` } style={ btnbgstyle } href={ btnlink } role="button" key={ `${ i }-${ j }` }>
                    { btnpretitleComp }
                    { btntitleComp }
                </a>
            )

            return output
        } )

        const output = (
            <div className={ `slider` } key={ i }>
                <div className={ `rounded-lg px-md-5 text-center text-xl-left ${ bgColor }` } style={ bgstyle }>
                    <div className="d-xl-flex justify-content-between align-items-center px-4 px-sm-5 mx-auto slider-inner">
                        <div className="py-5 mr-xl-4 mx-auto mx-xl-0 slider-content">
                            { titleComp }
                            { subtitleComp }
                            { buttontitleComp }
                            { enableButton && btncontent }
                        </div>
                        <div>
                            <img src={ MediaURL ? MediaURL : defaultImg } alt="Image" />
                        </div>
                    </div>
                </div>
            </div>
        )

        return output
    } )

    const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-3.main-block.classes', {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots : false,
        arrows : true,
        adaptiveHeight : true,
        prevArrow: '<i class="czi-arrow-left"></i>',
        nextArrow: '<i class="czi-arrow-right"></i>',
        speed: 500,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    nav: true,
                    controls: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    nav: false,
                    controls: true
                }
            },
        ],
    }, props )

    let carouselOptions = {
        fade: true,
        mode: "gallery",
        speed: 1000,
    }

    carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

    return (
        <div id={ blockId } className={ mainClasses }>
            <div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
                { content }
            </div>
        </div>
    )
}



const schema_2 = {
    blockId: {
        type: 'string',
        default: '',
    },

    limit: {
        type: 'number',
        default: 1,
    },

    enableButton: {
        type: 'boolean',
        default: true,
    },
    autoplay: {
        type: 'boolean',
        default: false,
    },

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit_2 = applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit_2 + 1 ).map( i => {
    schema_2[ `title${ i }` ] = {
        type: 'string',
    }
    schema_2[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema_2[ `buttontitle${ i }` ] = {
        type: 'string',
    }
    schema_2[ `backgroundImage${ i }` ] = {
        type: 'string',
    }
    schema_2[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema_2[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema_2[ `mediaURL${ i }` ] = {
        type: 'string',
    }
    schema_2[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_2[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_2[ `enablebuttonTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
     schema_2[ `enableButton${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_2[ `titleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_2[ `titleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_2[ `subtitleAnimation${ i }` ] = {
        type: 'string',
        default: 'from-bottom'
    }
    schema_2[ `subtitleDelay${ i }` ] = {
        type: 'string',
        default: 'delay-2'
    }
    schema_2[ `buttontitleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_2[ `buttontitleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_2[ `btnlimit${ i }` ] = {
        type: 'number',
        default: 2,
    }

    const Maxbtnlimit_2 = applyFilters( 'cartzillagb.market-button.btnlimit.edit.inspector.max.btnlimit', 4 )

    { range( 1, Maxbtnlimit_2 + 1 ).map( j => {
        schema_2[ `btnpretitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_2[ `btntitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_2[ `btnbgcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_2[ `btnbgcustomcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_2[ `btnicon${ i }${ j }` ] = {
            type: 'string',
        }
        schema_2[ `btnlink${ i }${ j }` ] = {
            type: 'string',
        }
        return ''
    } ) }

    schema_2[ `btnpretitle${ i }` ] = {
        type: 'string',
    }
    return ""
} ) }


const save_2 = props => {
    const { 
        attributes,
        className,
        
        // Carousel
    } = props 

    const {
        blockId,
        limit,
        autoplay
    } = attributes

    const mainClasses = classnames( [
        'cz-carousel',
        'mb-4',
        'mb-sm-5',
        className,
    ], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

    const content = range( 1, limit + 1 ).map( i => {

        const Title = attributes[ `title${ i }` ]
        const subTitle = attributes[ `subtitle${ i }` ]
        const ButtonTitle = attributes[ `buttontitle${ i }` ]
        const MediaURL = attributes[ `mediaURL${ i }` ]
        const bgColor = attributes[ `bgcolor${ i }` ]
        const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
        const enableTitle = attributes[ `enableTitle${ i }` ]
        const enablesubTitle = attributes[ `enablesubTitle${ i }` ]
        const enablebuttonTitle = attributes[ `enablebuttonTitle${ i }` ]
        const btnlimit = attributes[ `btnlimit${ i }` ]
        const enableButton = attributes[ `enableButton${ i }` ]

        let defaultTitle = ''
        let defaultSubtitle = ''
        let defaultButtonTitle = ''
        let defaultbgColor = ''
        const defaultImg = `${ srcUrl }/${ PlaceholderImage }`

        if ( i % 5 === 1 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 2 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 3 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 4 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 0 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }

        const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

        const titleComp = enableTitle && (
            <RichText.Content
                tagName="h2"
                className={ `h1 text-light` } 
                value={ Title || defaultTitle }
            />
        )

        const subtitleComp = enablesubTitle &&  (
            <RichText.Content
                tagName="p"
                value={ subTitle || defaultSubtitle }
                className={ `text-light pb-4` }
            />
        )

        const buttontitleComp = enablebuttonTitle && (
            <RichText.Content
                tagName="h5"
                className={ `text-light pb-3 text-light` } 
                value={ ButtonTitle || defaultButtonTitle }
            />
        )


        const btncontent = range( 1, ( btnlimit ) + 1 ).map( j => {
            const btnPreTitle = attributes[ `btnpretitle${ i }${ j }` ]
            const btnTitle = attributes[ `btntitle${ i }${ j }` ]
            const btnbgColor = attributes[ `btnbgcolor${ i }${ j }` ]
            const btnbgcustomColor = attributes[ `btnbgcustomcolor${ i }${ j }` ]
            const btnicon = attributes[ `btnicon${ i }${ j }` ]
            const btnlink = attributes[ `btnlink${ i }${ j }` ] !== undefined ? attributes[ `btnlink${ i }${ j }` ]  : '#'

            let defaultbtntitle = ''
            let defaultbtnpretitle = ''
            let defaultbtnIcon = ''

            if ( (j % 4 ) === 1 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "App Store"
                defaultbtnIcon = 'btn-apple'
            }

            if ( (j % 4 ) === 2 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Google Play"
                defaultbtnIcon = 'btn-google'
            }

            if ( (j % 4 ) === 3 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Windows Store"
                defaultbtnIcon = 'btn-windows'
            }

            if ( (j % 4 ) === 0 ) { 
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Amazon.com"
                defaultbtnIcon = 'btn-amazon'
            }

            const btnbgstyle = { backgroundColor: btnbgcustomColor && btnbgcustomColor }

            const btniconClass = classnames( [
                btnicon === 'none' && '',
                btnicon === 'btn-apple' && ' btn-apple',
                btnicon === 'btn-google' && ' btn-google',
                btnicon === 'btn-windows' && ' btn-windows',
                btnicon === 'btn-amazon' && ' btn-amazon'
            ] )

            const btnpretitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-subtitle"
                    value={ btnPreTitle || defaultbtnpretitle }
                />
            )

            const btntitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-title"
                    value={ btnTitle || defaultbtntitle }
                />
            )

            const output = (
                <a className={ `btn-market ${ btniconClass || defaultbtnIcon } mr-2 mb-2 ${ btnbgColor ? btnbgColor : btnbgcustomColor ? '' : '' }` } style={ btnbgstyle } href={ btnlink } role="button" key={ `${ i }-${ j }` }>
                    { btnpretitleComp }
                    { btntitleComp }
                </a>
            )

            return output
        } )

        const output = (
            <div className={ `slider` } key={ i }>
                <div className={ `rounded-lg px-md-5 text-center text-xl-left ${ bgColor }` } style={ bgstyle }>
                    <div className="d-xl-flex justify-content-between align-items-center px-4 px-sm-5 mx-auto slider-inner">
                        <div className="py-5 mr-xl-4 mx-auto mx-xl-0 slider-content">
                            { titleComp }
                            { subtitleComp }
                            { buttontitleComp }
                            { enableButton && btncontent }
                        </div>
                        <div>
                            <img src={ MediaURL ? MediaURL : defaultImg } alt="Image" />
                        </div>
                    </div>
                </div>
            </div>
        )

        return output
    } )

    const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-3.main-block.classes', {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots : false,
        arrows : true,
        adaptiveHeight : true,
        prevArrow: '<i class="czi-arrow-left"></i>',
        nextArrow: '<i class="czi-arrow-right"></i>',
        speed: 500,
        autoplay: autoplay,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    nav: true,
                    controls: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    nav: false,
                    controls: true
                }
            },
        ],
    }, props )

    let carouselOptions = {
        fade: true,
        mode: "gallery",
        speed: 1000,
    }

    carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

    return (
        <div id={ blockId } className={ mainClasses }>
            <div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
                { content }
            </div>
        </div>
    )
}


const schema_3 = {
    blockId: {
        type: 'string',
        default: '',
    },

    limit: {
        type: 'number',
        default: 1,
    },

    enableButton: {
        type: 'boolean',
        default: true,
    },
    autoplay: {
        type: 'boolean',
        default: false,
    },
    speed: {
        type: 'number',
        default: 1000,
    },

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit_3 = applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit_3 + 1 ).map( i => {
    schema_3[ `title${ i }` ] = {
        type: 'string',
    }
    schema_3[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema_3[ `buttontitle${ i }` ] = {
        type: 'string',
    }
    schema_3[ `backgroundImage${ i }` ] = {
        type: 'string',
    }
    schema_3[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema_3[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema_3[ `mediaURL${ i }` ] = {
        type: 'string',
    }
    schema_3[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_3[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_3[ `enablebuttonTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
     schema_3[ `enableButton${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_3[ `titleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_3[ `titleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_3[ `subtitleAnimation${ i }` ] = {
        type: 'string',
        default: 'from-bottom'
    }
    schema_3[ `subtitleDelay${ i }` ] = {
        type: 'string',
        default: 'delay-2'
    }
    schema_3[ `buttontitleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_3[ `buttontitleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_3[ `btnlimit${ i }` ] = {
        type: 'number',
        default: 2,
    }

    const Maxbtnlimit_3 = applyFilters( 'cartzillagb.market-button.btnlimit.edit.inspector.max.btnlimit', 4 )

    { range( 1, Maxbtnlimit_3 + 1 ).map( j => {
        schema_3[ `btnpretitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_3[ `btntitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_3[ `btnbgcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_3[ `btnbgcustomcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_3[ `btnicon${ i }${ j }` ] = {
            type: 'string',
        }
        schema_3[ `btnlink${ i }${ j }` ] = {
            type: 'string',
        }
        return ''
    } ) }

    schema_3[ `btnpretitle${ i }` ] = {
        type: 'string',
    }
    return ""
} ) }


const save_3 = props => {
    const { 
        attributes,
        className,
        
        // Carousel
    } = props 

    const {
        blockId,
        limit,
        autoplay,
        speed
    } = attributes

    const mainClasses = classnames( [
        'cz-carousel',
        'mb-4',
        'mb-sm-5',
        className,
    ], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

    const content = range( 1, limit + 1 ).map( i => {

        const Title = attributes[ `title${ i }` ]
        const subTitle = attributes[ `subtitle${ i }` ]
        const ButtonTitle = attributes[ `buttontitle${ i }` ]
        const MediaURL = attributes[ `mediaURL${ i }` ]
        const bgColor = attributes[ `bgcolor${ i }` ]
        const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
        const enableTitle = attributes[ `enableTitle${ i }` ]
        const enablesubTitle = attributes[ `enablesubTitle${ i }` ]
        const enablebuttonTitle = attributes[ `enablebuttonTitle${ i }` ]
        const btnlimit = attributes[ `btnlimit${ i }` ]
        const enableButton = attributes[ `enableButton${ i }` ]

        let defaultTitle = ''
        let defaultSubtitle = ''
        let defaultButtonTitle = ''
        let defaultbgColor = ''
        const defaultImg = `${ srcUrl }/${ PlaceholderImage }`

        if ( i % 5 === 1 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 2 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 3 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 4 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 0 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }

        const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

        const titleComp = enableTitle && (
            <RichText.Content
                tagName="h2"
                className={ `h1 text-light` } 
                value={ Title || defaultTitle }
            />
        )

        const subtitleComp = enablesubTitle &&  (
            <RichText.Content
                tagName="p"
                value={ subTitle || defaultSubtitle }
                className={ `text-light pb-4` }
            />
        )

        const buttontitleComp = enablebuttonTitle && (
            <RichText.Content
                tagName="h5"
                className={ `text-light pb-3 text-light` } 
                value={ ButtonTitle || defaultButtonTitle }
            />
        )


        const btncontent = range( 1, ( btnlimit ) + 1 ).map( j => {
            const btnPreTitle = attributes[ `btnpretitle${ i }${ j }` ]
            const btnTitle = attributes[ `btntitle${ i }${ j }` ]
            const btnbgColor = attributes[ `btnbgcolor${ i }${ j }` ]
            const btnbgcustomColor = attributes[ `btnbgcustomcolor${ i }${ j }` ]
            const btnicon = attributes[ `btnicon${ i }${ j }` ]
            const btnlink = attributes[ `btnlink${ i }${ j }` ] !== undefined ? attributes[ `btnlink${ i }${ j }` ]  : '#'

            let defaultbtntitle = ''
            let defaultbtnpretitle = ''
            let defaultbtnIcon = ''

            if ( (j % 4 ) === 1 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "App Store"
                defaultbtnIcon = 'btn-apple'
            }

            if ( (j % 4 ) === 2 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Google Play"
                defaultbtnIcon = 'btn-google'
            }

            if ( (j % 4 ) === 3 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Windows Store"
                defaultbtnIcon = 'btn-windows'
            }

            if ( (j % 4 ) === 0 ) { 
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Amazon.com"
                defaultbtnIcon = 'btn-amazon'
            }

            const btnbgstyle = { backgroundColor: btnbgcustomColor && btnbgcustomColor }

            const btniconClass = classnames( [
                btnicon === 'none' && '',
                btnicon === 'btn-apple' && ' btn-apple',
                btnicon === 'btn-google' && ' btn-google',
                btnicon === 'btn-windows' && ' btn-windows',
                btnicon === 'btn-amazon' && ' btn-amazon'
            ] )

            const btnpretitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-subtitle"
                    value={ btnPreTitle || defaultbtnpretitle }
                />
            )

            const btntitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-title"
                    value={ btnTitle || defaultbtntitle }
                />
            )

            const output = (
                <a className={ `btn-market ${ btniconClass || defaultbtnIcon } mr-2 mb-2 ${ btnbgColor ? btnbgColor : btnbgcustomColor ? '' : '' }` } style={ btnbgstyle } href={ btnlink } role="button" key={ `${ i }-${ j }` }>
                    { btnpretitleComp }
                    { btntitleComp }
                </a>
            )

            return output
        } )

        const output = (
            <div className={ `slider` } key={ i }>
                <div className={ `rounded-lg px-md-5 text-center text-xl-left ${ bgColor }` } style={ bgstyle }>
                    <div className="d-xl-flex justify-content-between align-items-center px-4 px-sm-5 mx-auto slider-inner">
                        <div className="py-5 mr-xl-4 mx-auto mx-xl-0 slider-content">
                            { titleComp }
                            { subtitleComp }
                            { buttontitleComp }
                            { enableButton && btncontent }
                        </div>
                        <div>
                            <img src={ MediaURL ? MediaURL : defaultImg } alt="Image" />
                        </div>
                    </div>
                </div>
            </div>
        )

        return output
    } )

    const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-3.main-block.classes', {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots : false,
        arrows : true,
        adaptiveHeight : true,
        prevArrow: '<i class="czi-arrow-left"></i>',
        nextArrow: '<i class="czi-arrow-right"></i>',
        speed: speed,
        autoplay: autoplay,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    nav: true,
                    controls: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    nav: false,
                    controls: true
                }
            },
        ],
    }, props )

    let carouselOptions = {
        fade: true,
        mode: "gallery"
    }

    carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

    return (
        <div id={ blockId } className={ mainClasses }>
            <div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
                { content }
            </div>
        </div>
    )
}

const schema_4 = {
    blockId: {
        type: 'string',
        default: '',
    },

    limit: {
        type: 'number',
        default: 1,
    },

    enableButton: {
        type: 'boolean',
        default: true,
    },
    autoplay: {
        type: 'boolean',
        default: false,
    },
    speed: {
        type: 'number',
        default: 1000,
    },
    autoplaySpeed: {
        type: 'number',
        default: 1000,
    },

    

    ...createButtonAttributes( 'button1%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button2%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button3%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button4%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
    ...createButtonAttributes( 'button5%s', { 
        defaultText: 'Shop Now',
        iconAfterText: true,
        defaultIcon: 'czi-arrow-right',
        defaultAnimation: 'scale-up',
        defaultDelay: 'delay-4' 
    } ),
}

const Maxlimit_4 = applyFilters( 'cartzillagb.hero-carousel-3.edit.inspector.max.limit', 5 )

{ range( 1, Maxlimit_4 + 1 ).map( i => {
    schema_4[ `title${ i }` ] = {
        type: 'string',
    }
    schema_4[ `subtitle${ i }` ] = {
        type: 'string',
    }
    schema_4[ `buttontitle${ i }` ] = {
        type: 'string',
    }
    schema_4[ `backgroundImage${ i }` ] = {
        type: 'string',
    }
    schema_4[ `bgcolor${ i }` ] = {
        type: 'string',
    }
    schema_4[ `bgcustomcolor${ i }` ] = {
        type: 'string',
    }
    schema_4[ `mediaURL${ i }` ] = {
        type: 'string',
    }
    schema_4[ `enableTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_4[ `enablesubTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_4[ `enablebuttonTitle${ i }` ] = {
        type: 'boolean',
        default: true,
    }
     schema_4[ `enableButton${ i }` ] = {
        type: 'boolean',
        default: true,
    }
    schema_4[ `titleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_4[ `titleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_4[ `subtitleAnimation${ i }` ] = {
        type: 'string',
        default: 'from-bottom'
    }
    schema_4[ `subtitleDelay${ i }` ] = {
        type: 'string',
        default: 'delay-2'
    }
    schema_4[ `buttontitleAnimation${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_4[ `buttontitleDelay${ i }` ] = {
        type: 'string',
        default: 'none'
    }
    schema_4[ `btnlimit${ i }` ] = {
        type: 'number',
        default: 2,
    }

    const Maxbtnlimit_4 = applyFilters( 'cartzillagb.market-button.btnlimit.edit.inspector.max.btnlimit', 4 )

    { range( 1, Maxbtnlimit_4 + 1 ).map( j => {
        schema_4[ `btnpretitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_4[ `btntitle${ i }${ j }` ] = {
            type: 'string',
        }
        schema_4[ `btnbgcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_4[ `btnbgcustomcolor${ i }${ j }` ] = {
            type: 'string',
        }
        schema_4[ `btnicon${ i }${ j }` ] = {
            type: 'string',
        }
        schema_4[ `btnlink${ i }${ j }` ] = {
            type: 'string',
        }
        return ''
    } ) }

    schema_4[ `btnpretitle${ i }` ] = {
        type: 'string',
    }
    return ""
} ) }

const save_4 = props => {
    const { 
        attributes,
        className,
        
        // Carousel
    } = props 

    const {
        blockId,
        limit,
        autoplay,
        speed,
        autoplaySpeed
    } = attributes

    const mainClasses = classnames( [
        'cz-carousel',
        'mb-4',
        'mb-sm-5',
        className,
    ], applyFilters( `cartzillagb.${ name.replace( 'czgb/', '' ) }.main-block.classes`, {}, props ) )

    const content = range( 1, limit + 1 ).map( i => {

        const Title = attributes[ `title${ i }` ]
        const subTitle = attributes[ `subtitle${ i }` ]
        const ButtonTitle = attributes[ `buttontitle${ i }` ]
        const MediaURL = attributes[ `mediaURL${ i }` ]
        const bgColor = attributes[ `bgcolor${ i }` ]
        const bgcustomColor = attributes[ `bgcustomcolor${ i }` ]
        const enableTitle = attributes[ `enableTitle${ i }` ]
        const enablesubTitle = attributes[ `enablesubTitle${ i }` ]
        const enablebuttonTitle = attributes[ `enablebuttonTitle${ i }` ]
        const btnlimit = attributes[ `btnlimit${ i }` ]
        const enableButton = attributes[ `enableButton${ i }` ]

        let defaultTitle = ''
        let defaultSubtitle = ''
        let defaultButtonTitle = ''
        let defaultbgColor = ''
        const defaultImg = `${ srcUrl }/${ PlaceholderImage }`

        if ( i % 5 === 1 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 2 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 3 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }
        if ( i % 5 === 4 ) {
            defaultTitle = '24/7 Delivery Service'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#1a6fb0'
        }
        if ( i % 5 === 0 ) {
            defaultTitle = 'Fresh Foods a Click Away'
            defaultSubtitle = 'Order any goods from our store online and we deliver them to your door at a time convenient for you.'
            defaultButtonTitle = 'On the go? Try our mobile app'
            defaultbgColor = '#59c879'
        }

        const bgstyle = { backgroundColor: bgcustomColor !== undefined ? bgcustomColor : defaultbgColor }

        const titleComp = enableTitle && (
            <RichText.Content
                tagName="h2"
                className={ `h1 text-light` } 
                value={ Title || defaultTitle }
            />
        )

        const subtitleComp = enablesubTitle &&  (
            <RichText.Content
                tagName="p"
                value={ subTitle || defaultSubtitle }
                className={ `text-light pb-4` }
            />
        )

        const buttontitleComp = enablebuttonTitle && (
            <RichText.Content
                tagName="h5"
                className={ `text-light pb-3 text-light` } 
                value={ ButtonTitle || defaultButtonTitle }
            />
        )


        const btncontent = range( 1, ( btnlimit ) + 1 ).map( j => {
            const btnPreTitle = attributes[ `btnpretitle${ i }${ j }` ]
            const btnTitle = attributes[ `btntitle${ i }${ j }` ]
            const btnbgColor = attributes[ `btnbgcolor${ i }${ j }` ]
            const btnbgcustomColor = attributes[ `btnbgcustomcolor${ i }${ j }` ]
            const btnicon = attributes[ `btnicon${ i }${ j }` ]
            const btnlink = attributes[ `btnlink${ i }${ j }` ] !== undefined ? attributes[ `btnlink${ i }${ j }` ]  : '#'

            let defaultbtntitle = ''
            let defaultbtnpretitle = ''
            let defaultbtnIcon = ''

            if ( (j % 4 ) === 1 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "App Store"
                defaultbtnIcon = 'btn-apple'
            }

            if ( (j % 4 ) === 2 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Google Play"
                defaultbtnIcon = 'btn-google'
            }

            if ( (j % 4 ) === 3 ) {
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Windows Store"
                defaultbtnIcon = 'btn-windows'
            }

            if ( (j % 4 ) === 0 ) { 
                defaultbtnpretitle = "Download on the"
                defaultbtntitle = "Amazon.com"
                defaultbtnIcon = 'btn-amazon'
            }

            const btnbgstyle = { backgroundColor: btnbgcustomColor && btnbgcustomColor }

            const btniconClass = classnames( [
                btnicon === 'none' && '',
                btnicon === 'btn-apple' && ' btn-apple',
                btnicon === 'btn-google' && ' btn-google',
                btnicon === 'btn-windows' && ' btn-windows',
                btnicon === 'btn-amazon' && ' btn-amazon'
            ] )

            const btnpretitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-subtitle"
                    value={ btnPreTitle || defaultbtnpretitle }
                />
            )

            const btntitleComp =(
                <RichText.Content
                    tagName="span"
                    className="btn-market-title"
                    value={ btnTitle || defaultbtntitle }
                />
            )

            const output = (
                <a className={ `btn-market ${ btniconClass || defaultbtnIcon } mr-2 mb-2 ${ btnbgColor ? btnbgColor : btnbgcustomColor ? '' : '' }` } style={ btnbgstyle } href={ btnlink } role="button" key={ `${ i }-${ j }` }>
                    { btnpretitleComp }
                    { btntitleComp }
                </a>
            )

            return output
        } )

        const output = (
            <div className={ `slider` } key={ i }>
                <div className={ `rounded-lg px-md-5 text-center text-xl-left ${ bgColor }` } style={ bgstyle }>
                    <div className="d-xl-flex justify-content-between align-items-center px-4 px-sm-5 mx-auto slider-inner">
                        <div className="py-5 mr-xl-4 mx-auto mx-xl-0 slider-content">
                            { titleComp }
                            { subtitleComp }
                            { buttontitleComp }
                            { enableButton && btncontent }
                        </div>
                        <div>
                            <img src={ MediaURL ? MediaURL : defaultImg } alt="Image" />
                        </div>
                    </div>
                </div>
            </div>
        )

        return output
    } )

    const defaultCarouselOptions = applyFilters( 'cartzillagb.hero-carousel-3.main-block.classes', {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots : false,
        arrows : true,
        adaptiveHeight : true,
        prevArrow: '<i class="czi-arrow-left"></i>',
        nextArrow: '<i class="czi-arrow-right"></i>',
        speed: speed,
        autoplay: autoplay,
        autoplaySpeed: autoplaySpeed,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    nav: true,
                    controls: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    nav: false,
                    controls: true
                }
            },
        ],
    }, props )

    let carouselOptions = {
        fade: true,
        mode: "gallery"
    }

    carouselOptions = { ...defaultCarouselOptions, ...carouselOptions }

    return (
        <div id={ blockId } className={ mainClasses }>
            <div className="js-slick-carousel" data-slick={ JSON.stringify( carouselOptions ) }>
                { content }
            </div>
        </div>
    )
}

const deprecated = [
    {
        attributes: schema_1,
        save: save_1,
    },
    {
        attributes: schema_2,
        save: save_2,
    },
    {
        attributes: schema_3,
        save: save_3,
    },
    {
        attributes: schema_4,
        save: save_4,
    },
]

export default deprecated